import {RefObject, useEffect} from 'react'

/**
 * While `open`, closes a dropdown on a mouse-down outside `containerRef`, and on Escape, after which
 * focus returns to `triggerRef`.
 */
export const useDismissOnOutside = (
  open: boolean,
  close: () => void,
  containerRef: RefObject<HTMLElement>,
  triggerRef?: RefObject<HTMLElement>
): void => {
  useEffect(() => {
    if (!open) return
    const onMouseDown = (e: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(e.target as Node)) close()
    }
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key !== 'Escape') return
      close()
      triggerRef?.current?.focus()
    }
    document.addEventListener('mousedown', onMouseDown)
    document.addEventListener('keydown', onKeyDown)
    return () => {
      document.removeEventListener('mousedown', onMouseDown)
      document.removeEventListener('keydown', onKeyDown)
    }
  }, [open, close, containerRef, triggerRef])
}
